export const categoryClass = (currentCategory, categoryId) =>
  currentCategory === categoryId ? 'category selected-category' : 'category'



// WEBPACK FOOTER //
// ./src/components/Elements/Sidebar/Categories/CategoryClass.js